import "./Logo.css";
import LogoImg from "../../asset/logo-white_mobil.webp";

function LogoMobil() {
  return (
    <img src={LogoImg} alt="Logo de La Tournée Des Plages" className="logo" />
  );
}

export default LogoMobil;
